import * as sentry from '@sentry/nextjs';

class SentryService {
  captureException(error: unknown, extra?: Record<string, unknown>) {
    sentry.captureException(error, {
      extra: { originalException: error, ...extra },
    });
  }

  captureMessage(
    message: string,
    level: sentry.SeverityLevel = 'warning',
    extra?: Record<string, unknown>,
  ) {
    sentry.captureMessage(message, { extra, level });
  }
}

export const sentryService = new SentryService();
